// extracted by mini-css-extract-plugin
module.exports = {"iconTouchArea":"Icon-module--iconTouchArea--Qw3e0","icon":"Icon-module--icon--Gpyvw"};